// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-btn {\n}\n\n.DropdownButtonWrapper--3TPg6yWe .ant-btn {\n    padding: 4px 10px;\n  }\n\n.DropdownButtonWrapper--3TPg6yWe .ant-btn-icon-only {\n    width: auto;\n    min-width: 32px;\n    padding: 0 10px;\n  }\n\n.DropdownButtonWrapper--3TPg6yWe .ant-btn-icon-only > * {\n    font-size: 14px;\n  }\n\n.DropdownButtonWrapper--3TPg6yWe .LeftButtonLabel--3nBVFmUj {\n    margin-left: 5px;\n  }\n\n.DropdownButtonWrapper--3TPg6yWe .RightButtonLabel--3IcNY5ND {\n    margin-right: 5px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DropdownButtonWrapper": "DropdownButtonWrapper--3TPg6yWe",
	"LeftButtonLabel": "LeftButtonLabel--3nBVFmUj",
	"RightButtonLabel": "RightButtonLabel--3IcNY5ND"
};
export default ___CSS_LOADER_EXPORT___;
